import { IconChevronDropdownDown } from '@doltech/icons/IconChevronDropdownDown';
import { leftPad } from '@doltech/utils/lib/number';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import { useToggle } from 'react-use';
import { RenderElementProps } from 'slate-react';
import styled from 'styled-components';
import { Cell, Grid } from 'styled-css-grid';

import { colorsV2 } from '../../../../../colors-v2';
import { Box } from '../../../../../Common/BoxV2';
import { Typography } from '../../../../../DesignSystemV2/Typography';
import { Nothing } from '../../../../shared-components/Nothing';
import { useExerciseShortAnswerDoTestStore } from '../../store/exercise-short-answer-do-test.store';
import { EXERCISE_SHORT_ANSWER_QUESTION, SHORT_ANSWER_PARAGRAPH_TOGGLE_TYPES } from '../../types';
import { useRootElement } from '../../../../../../slatePlugins/common/hocs/current-element.store';
import { findBellowByType } from '../../../../../DolEditor/helpers/nodeValue';

/* stylelint-disable */
export const ParagraphToggleOverrided = (props: RenderElementProps) => {
  const { element, children } = props;

  if (!element.visible && SHORT_ANSWER_PARAGRAPH_TOGGLE_TYPES.QUESTION)
    return <Nothing {...props} />;

  switch (element.present) {
    case SHORT_ANSWER_PARAGRAPH_TOGGLE_TYPES.QUESTION:
      return <QuestionSubject {...props} />;
    case SHORT_ANSWER_PARAGRAPH_TOGGLE_TYPES.EXPLANATION:
      return <ResultExplanation {...props} />;
    case SHORT_ANSWER_PARAGRAPH_TOGGLE_TYPES.GUIDE:
      return <NormalParagraph {...props} />;
    default:
      return children;
  }
};

const QuestionSubject = (props: RenderElementProps) => {
  const { element, children, attributes } = props;
  const exerciseShortAnswer = useRootElement();
  const questions = findBellowByType(exerciseShortAnswer, EXERCISE_SHORT_ANSWER_QUESTION);
  const questionIndex = questions.findIndex((question) =>
    question.children.some((child) => child === element)
  );

  return (
    <Style
      className="do-test-exercise-short-question-subject font-inter"
      contentEditable={false}
      {...attributes}
    >
      <Box display="flex" alignItems="baseline">
        <Typography.Text
          variant="semi-bold/18"
          tabletVariant="semi-bold/20"
          color="blue100"
          mr="3px"
        >
          {`${leftPad(exerciseShortAnswer.startFrom + questionIndex, 2)}. `}
        </Typography.Text>
        <Box flex={1} display={element.visible ? 'block' : 'none'}>
          {children}
        </Box>
      </Box>
    </Style>
  );
};

function ResultExplanationBase(props: RenderElementProps) {
  const { children, attributes } = props;
  const store = useExerciseShortAnswerDoTestStore();

  const [expand, toggle] = useToggle(true);

  return (
    <Style
      className="do-test-exercise-short-result-explanation font-inter"
      contentEditable={false}
      style={{ display: store.isViewResult ? 'block' : 'none' }}
      {...attributes}
    >
      <Box p="16px" backgroundColor="gray10" borderRadius="8px">
        <Grid
          columns="max-content 1fr"
          gap="10px"
          onClick={() => toggle()}
          contentEditable={false}
          style={{ cursor: 'pointer' }}
        >
          <Cell middle>
            <IconChevronDropdownDown
              style={{
                transform: `rotate(${expand ? 0 : 180}deg)`,
                transition: '200ms',
                width: 24,
                height: 24,
                color: colorsV2.black100,
              }}
            />
          </Cell>

          <Typography.Text variant="semi-bold/18" tabletVariant="semi-bold/20">
            Giải thích chi tiết
          </Typography.Text>
        </Grid>

        <Box mt="16px" display={expand ? 'block' : 'none'}>
          {children}
        </Box>
      </Box>
    </Style>
  );
}

const ResultExplanation = observer(ResultExplanationBase);

function NormalParagraph(props: RenderElementProps) {
  const { children, attributes } = props;
  return <Style {...attributes}>{children}</Style>;
}

const Style = styled.div`
  &&& {
    user-select: none;

    p {
      margin: 0;
    }
  }
`;
